// extracted by mini-css-extract-plugin
export default {"disabledPage":"style_disabledPage__g1JaI","activePage":"style_activePage__ZvaKv","previousBtn":"style_previousBtn__Z6Z3S","nextBtn":"style_nextBtn__8cuJn"};